import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Range, getTrackBackground } from 'react-range'
import IMG_0_1 from 'assets/images/rate_plan/main_img.png'
import IMG_1_1 from 'assets/images/gogoro-network/sub-battery-plan-img-pc.png'
import IMG_1_2 from 'assets/images/rate_plan/sub-battery-plan-img-pad.png'
import IMG_1_3 from 'assets/images/gogoro-network/sub-battery-plan-img-mobile.png'
import IMG_2_1 from 'assets/images/rate_plan/graph_pc.png'
import IMG_2_2 from 'assets/images/rate_plan/graph_pad.png'
import IMG_2_3 from 'assets/images/rate_plan/graph_mobile.png'
import IMG_3_1 from 'assets/images/rate_plan/2plus_pc.png'
import IMG_3_2 from 'assets/images/rate_plan/2plus_mobile.png'
import IMG_4_1 from 'assets/images/rate_plan/thumb_icon_pc.png'
import IMG_4_2 from 'assets/images/rate_plan/thumb_icon_mobile.png'

import { API_CODE, PLAN_TYPE, MOBILE, COMPANY_NAME_KO, COMPANY_CALL } from 'utils/Utils'
import { priceToString } from 'utils/UtilsFunction'
import './RatePlanMain.scss'

/**
 * @file 요금제 main 화면
 */
function RatePlanMain() {
    const MAX_KM = 5000
    const MIN_KM = 50
    const STEP_KM = 50
    const RIDE_TYPE_OPTION = [
        {
            name: '출퇴근 및 레저',
            type: '1',
        },
        {
            name: '배달 및 상용',
            type: '3',
        },
    ]
    const [recommendRatePlanVal, setRecommendRatePlanVal] = useState({
        rideType: RIDE_TYPE_OPTION[0].type,
        kmVal: [MIN_KM],
    })
    const [rateData, setRateData] = useState([]) //요금제 data
    const [recommendRateData, setRecommendRateData] = useState([]) //추쳔요금제 data
    const [width, setWidth] = useState(window.innerWidth) // 사용자의 화면 너비
    const [recommendItemHeight, setRecommendItemHeight] = useState('') // 두 div의 높이 상태
    const recomendWrapRef = useRef()

    // 사용자의 화면 너비가 바뀔때마다 변수에 담아줌
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        getRatePlan()

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (recommendItemHeight === 'fit-content') {
            let recommendOneDiv = document.getElementById('ratecommend-item-0')
            let recommendTwoDiv = document.getElementById('ratecommend-item-1')

            if (recommendOneDiv && recommendTwoDiv) {
                const maxHeight = Math.max(recommendOneDiv.scrollHeight, recommendTwoDiv.scrollHeight)
                setRecommendItemHeight(`${maxHeight}px`)
            }
        }
    }, [recommendItemHeight])

    useEffect(() => {
        setRecommendItemHeight(`fit-content`)
    }, [recommendRateData])

    useEffect(() => {
        let recommendOneDiv = document.getElementById('ratecommend-item-0')

        if (recommendOneDiv) {
            setRecommendItemHeight(`fit-content`)
        }
    }, [width])

    //type으로 name 찾기
    const getNameByType = () => {
        const rideType = RIDE_TYPE_OPTION.find(option => option.type === recommendRatePlanVal.rideType)
        return rideType ? rideType.name : ''
    }

    //name으로 type 찾기
    const getTypeByName = val => {
        const rideType = RIDE_TYPE_OPTION.find(option => option.name === val)
        return rideType ? rideType.type : ''
    }

    //해당 영역으로 scrollTo
    const scrollToDiv = () => {
        let divTop = recomendWrapRef.current.offsetTop
        let navWrap = document.querySelector('nav')
        let navWrapHeight = navWrap.offsetHeight

        window.scrollTo({
            top: divTop - navWrapHeight,
            behavior: 'smooth',
        })
    }

    //이용요금제 api 조회
    const getRatePlan = () => {
        axios
            .get(`${process.env.REACT_APP_BASE_URL_NEW}/homepage/plan-item`, {
                params: {},
                headers: {
                    'gen-api-key': process.env.REACT_APP_DOT_KEY,
                    'access-token': 'DEV-PASS',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    setRateData([...response?.data?.data])
                } else {
                    alert(response?.data?.message)
                    setRateData([])
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                    setRateData([])
                }
            })
    }

    //요금제찾기 선택
    const ratePlanSearchClick = () => {
        getRatecommendSearch()
    }

    //추천 요금제 정보 조회
    const getRatecommendSearch = () => {
        axios
            .get(`${process.env.REACT_APP_BASE_URL_NEW}/homepage/plan-item/recommand`, {
                params: {
                    ride_type: recommendRatePlanVal.rideType, //(string)주행유형(출퇴근 및 레저 선택 시 = 1, 배달 및 상용 선택 시 = 3)
                    month_distance: String(recommendRatePlanVal.kmVal), //(string)월주행거리(km)
                },
                headers: {
                    'gen-api-key': process.env.REACT_APP_DOT_KEY,
                },
            })
            .then(response => {
                if (response?.data?.code === API_CODE.SUCCESS) {
                    setRecommendRateData([...response?.data?.data])
                } else {
                    alert(response?.data?.message)
                    setRecommendRateData([])
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                    setRecommendRateData([])
                }
            })
    }

    return (
        <>
            <div className="ratePlan-one">
                <div className="text-box">
                    <div className="t1">
                        다양한 맞춤형
                        <br />
                        요금제를 제공하는 {COMPANY_NAME_KO}
                    </div>
                    <div className="sub pc">
                        닷스테이션의 다양한 요금제는 사용자의 라이프 스타일에 맞춘
                        <br />
                        합리적인 요금제로 다양한 선택의 폭을 제공합니다.
                    </div>
                    <div className="sub mobile">
                        닷스테이션의 다양한 요금제는
                        <br />
                        사용자의 라이프 스타일에 맞춘 합리적인 요금제로
                        <br />
                        다양한 선택의 폭을 제공합니다.
                    </div>
                </div>
                <img className="main_img" src={IMG_0_1} alt="요금제 메인 이미지" />
            </div>
            <div className="ratePlan-two">
                <div className="table-box">
                    <div className="text-wrap">
                        <div className="text-box">
                            <p className="t1">스왑스테이션 이용 요금제</p>
                            <p className="sub">라이프 스타일에 맞는 요금제를 선택하여 라이딩을 즐겨보세요.</p>
                        </div>
                        <div className="text-btn" onClick={scrollToDiv}>
                            내게 맞는
                            <br />
                            요금제 찾기
                        </div>
                    </div>
                    {/* pc & pad 버전 */}
                    <ul className="plan-list pc">
                        <li>
                            <p className="title title-name">요금제</p>
                            <p className="title title-bettery">암페어</p>
                            <p className="title title-cost">
                                <span>이용금액</span>
                                <span className="vat"> (VAT 포함)</span>
                            </p>
                            <p className="title title-memo">요금제 설명</p>
                        </li>
                        {rateData.map(item => (
                            <li>
                                <p className="item-name">{item?.itemName}</p>
                                <p className="battery-ah">
                                    {/* 무제한 요금제의 경우 암페어 제공 X */}
                                    {item?.itemType === '3' ? `-` : `${priceToString(item?.batteryAhAmount)} Ah`}
                                    <br />
                                    {item?.itemType === '3' ? `` : `${item?.drivingDistanceKm} ${item?.distanceDegree}`}
                                </p>
                                <p className="cost">{`${priceToString(item.totalCost)}원`}</p>
                                <p className="memo">{item.memo}</p>
                            </li>
                        ))}
                    </ul>
                    {/* 모바일 버전 */}
                    <ul className="plan-list mobile">
                        {rateData.map(item => (
                            <li key={`${item?.itemName}_${item?.batteryAhAmount}`}>
                                <div className="plan-item">
                                    <div className="top">
                                        <span className="plan-item-name">{item?.item}</span>
                                        <div className="plan-sub-wrap">
                                            <span className="plan-sub">
                                                {item?.itemType === '3'
                                                    ? `무제한`
                                                    : `월 ${priceToString(item.batteryAhAmount)} Ah / ${
                                                          item.drivingDistanceKm
                                                      } ${item.distanceDegree}`}
                                            </span>
                                            <span className="plan-sub">{`${priceToString(item.totalCost)}원`}</span>
                                        </div>
                                    </div>
                                </div>
                                <p className="memo">{item.memo}</p>
                            </li>
                        ))}
                    </ul>
                    <div className="summary-box">
                        <p className="t1">요금제 가입 시 주의사항</p>
                        <ul className="summary-list">
                            <li>- 예상가능 주행거리는 기온 및 라이더의 주행습관에 따라 차이가 있을 수 있습니다.</li>
                            <li>- 배터리 1회 완충 시 소요되는 암페어는 약 74Ah 입니다.</li>
                            <li>
                                - 정액 요금제의 제공암페어가 모두 소진된 후에는 1Ah당 55원의 초과 요금이 부과됩니다.
                                (VAT 포함)
                            </li>
                            <li>
                                - 요금제 변경∙종료를 희망하는 경우, 고객센터 ({COMPANY_CALL})로 문의하시길 바랍니다.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="ratePlan-three">
                <p className="t1">SPORTS MODE</p>
                <img className="sub-battery-img pc" src={IMG_1_1} alt="부가서비스 이미지" />
                <img className="sub-battery-img pad" src={IMG_1_2} alt="부가서비스 이미지" />
                <img className="sub-battery-img mobile" src={IMG_1_3} alt="부가서비스 이미지" />
                <div className="summary-box">
                    <p className="t2">스포츠모드 가입시 주의사항</p>
                    <ul>
                        <li>- 스포츠모드는 월 선결제 방식이며 중도 해지 시 환불이 불가능한 상품입니다.</li>
                        <li>
                            - 스포츠모드를 종료하시고 싶으신 경우, 고객센터 {COMPANY_CALL} 으로 문의하시길 바랍니다.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="ratePlan-four">
                <div className="text-box">
                    <p className="sub">주행거리를 예측하여 요금제를 자유롭게 선택할 수 있습니다.</p>
                    <p className="t1">
                        주행거리(km)만큼 <br />월 요금제 지불
                    </p>
                    <p className="sub-2 pc">
                        출퇴근 고객을 위한 33요금제부터 배달업 종사자를 위한 라이더 요금제까지
                        <br />
                        요금제를 세분화하여 선택의 폭을 넓혔습니다.
                    </p>
                    <p className="sub-2 mobile">
                        출퇴근 고객을 위한 33요금제부터
                        <br />
                        배달업 종사자를 위한 라이더 요금제까지
                        <br />
                        요금제를 세분화하여 선택의 폭을 넓혔습니다.
                    </p>
                </div>
                <img className="graph-img pc" src={IMG_2_1} alt="요금제 그래프 이미지" />
                <img className="graph-img pad" src={IMG_2_2} alt="요금제 그래프 이미지" />
                <img className="graph-img mobile" src={IMG_2_3} alt="요금제 그래프 이미지" />
            </div>
            <div className="ratePlan-five">
                <div className="text-box" ref={recomendWrapRef}>
                    <p className="sub">요금제 선택 가이드</p>
                    <p className="t1">내게 맞는 요금제 찾기</p>
                    <p className="sub-2 pc">
                        사용하실 용도와 주행 거리를 선택하여 내게 맞는 적합한 요금제를 추천해드려요.
                    </p>
                    <p className="sub-2 mobile">
                        사용하실 용도와 주행 거리를 선택하여
                        <br />
                        내게 맞는 적합한 요금제를 추천해드려요.
                    </p>
                </div>
                <div className="select-box">
                    <select
                        onChange={e =>
                            setRecommendRatePlanVal({
                                ...recommendRatePlanVal,
                                rideType: getTypeByName(e.target.value),
                            })
                        }
                        value={getNameByType()}>
                        {RIDE_TYPE_OPTION.map(item => (
                            <option key={`${item.type}`} value={item.name}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
                <img className="scooter-img pc" src={IMG_3_1} alt="스쿠터" />
                <img className="scooter-img mobile" src={IMG_3_2} alt="스쿠터" />
                <div className="km-box">
                    <p className="t1">월 주행거리</p>
                    <div>
                        <span className="km-text">{`${priceToString(recommendRatePlanVal.kmVal)}`}Km</span>
                        <span className="month-text"> / 월</span>
                    </div>
                    <Range
                        step={STEP_KM}
                        min={MIN_KM}
                        max={MAX_KM}
                        values={recommendRatePlanVal.kmVal}
                        onChange={values => {
                            setRecommendRatePlanVal({
                                ...recommendRatePlanVal,
                                kmVal: [...values],
                            })
                        }}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                onTouchStart={props.onTouchStart}
                                {...props}
                                style={{
                                    ...props.style,
                                    height: width <= MOBILE ? '79px' : '120px',
                                    display: 'flex',
                                    width: '100%',
                                }}>
                                {children}
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: width <= MOBILE ? '10px' : '24px',
                                        width: '100%',
                                        borderRadius: '12px',
                                        background: getTrackBackground({
                                            values: recommendRatePlanVal.kmVal,
                                            colors: ['#3366ff', '#fff'],
                                            min: MIN_KM,
                                            max: MAX_KM,
                                        }),
                                        alignSelf: 'center',
                                    }}></div>
                            </div>
                        )}
                        renderThumb={({ props }) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    height: width <= MOBILE ? '32px' : '78px',
                                    width: width <= MOBILE ? '32px' : '78px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    background: width <= MOBILE ? `url(${IMG_4_2})` : `url(${IMG_4_1})`,
                                }}
                            />
                        )}
                    />
                    <p className="min-max-km-wrap">
                        <span>{`<${priceToString(MIN_KM)}Km`}</span>
                        <span>{`${priceToString(MAX_KM)}Km>`}</span>
                    </p>
                </div>
                <button className="recommend-rateplan-search-btn" onClick={() => ratePlanSearchClick()}>
                    요금제 찾기
                </button>
                <div className="recommend-rateplan-box">
                    {recommendRateData.length > 0 &&
                        recommendRateData.map((item, i) => (
                            <div
                                className="ratecommend-rateplan-item-box"
                                key={`ratecommend-item-${item.serialNumber}`}
                                id={`ratecommend-item-${i}`}
                                style={{ height: recommendItemHeight }}>
                                <div className="t1">{`추천요금제${i + 1}`}</div>
                                <div className="rateplan-name">{item.itemName}</div>
                                <div className="rateplan-info-wrap">
                                    {PLAN_TYPE.UNLIMITED !== item.itemType && (
                                        <>
                                            <span>{`${priceToString(item.batteryAhAmount)}Ah`}</span>
                                            <span> / </span>
                                        </>
                                    )}

                                    <span>{`${priceToString(item.totalCost)}원`}</span>
                                </div>
                                <div className="rateplan-desc">{item.memo}</div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    )
}

export default RatePlanMain
